export const testIds = {
  common: {
    spinner: 'common-spinner',
    sidebar: {
      right: 'common-sidebar-right',
    },
    listbox: 'common-listbox',
    toast: {
      success: 'common-toast-success',
      warning: 'common-toast-warning',
      error: 'common-toast-error',
      info: 'common-toast-info',
    },
    modal: 'common-modal',
    closeButton: 'common-close',
  },

  header: {
    avatar: 'header-avatar',
    login: 'header-login',
    languageSelector: 'header-lang-selector',
    newParcel: 'header-new-parcel',
    userMenu: 'header-user-menu',
  },

  sidebarMenu: {
    newParcel: 'sidebar-new-parcel',
  },

  parcelList: {
    parcelCard: 'parcel-list-card',
  },

  parceCreation: {
    priceBlock: 'price-block',
    parcelDetails: {
      departure: {
        countryInput: 'parcel-details-departure-country-input',
        postCodeInput: 'parcel-details-departure-postcode-input',
      },
      destination: {
        countryInput: 'parcel-details-destination-country-input',
        postCodeInput: 'parcel-details-destination-postcode-input',
      },
    },
    deliveryOptions: {
      card: 'delivery-option-card',
      mileOption: 'delivery-options-mile-option',
      middleMile: {
        air: 'air',
        sea: 'sea',
        expedited: 'expedited',
        car: 'car',
      },
      expandLastMilesButton: 'delivery-options-expand-last-miles',
      lastMilesMenu: 'delivery-options-last-miles-menu',
      priceSection: 'delivery-options-price-section',
    },
    parcelContent: {
      contentBlock: 'parcel-content-block',
    },
    summary: {
      checkboxes: 'summary-checkboxes',
    },
    recipient: {
      pudoInput: 'recipient-pudo-input',
    },
  },
};
